import { combineClassnames } from 'app/common/presentation'
import { DotIcon } from 'app/common/presentation/icons'
import { User } from 'app/user/types'

import { Avatar } from 'components'

import { getInitials } from '../../app/common/presentation/initials'
import styles from './AlertSnackbar.module.scss'

interface AlertSnackbarProps {
  className?: string
  text?: string
  user?: User
}

const AlertSnackbar = ({ className, text, user }: AlertSnackbarProps) => {
  return (
    <div className={combineClassnames(styles.alertSnackbar, className)}>
      {text && (
        <>
          <DotIcon className={styles.dot} />
          <div className={styles.text}>{text}</div>
        </>
      )}
      {user && (
        <>
          <Avatar className={styles.avatar} initials={getInitials(user)} />
          <div className={styles.text}>{`${user.firstName} ${user.lastName}`}</div>
        </>
      )}
    </div>
  )
}

export default AlertSnackbar
